'use client'
import { Button } from '@/components/ui/button'
import Image from 'next/image'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover'
import Text from '../../../text'
import { startTransition, useState } from 'react'
import { useIsB2BUser, useSession } from '@/lib/queries/session'
import { useAuthDialogStore } from '@/components/custom-ui/auth-forms/auth-dialog.store'
import Link from 'next/link'
import { useDictionary } from '../../navigation.dictionary'
import UserAvatar from './user-avatar'
import { useClearCart, withCartStoreSuspense } from '@/stores/cart-store'
import { getMenuItems } from './user-menu.utils'

const UserMenu = () => {
  const [isOpen, setIsOpen] = useState(false)
  const { data: session } = useSession()
  const clearCart = useClearCart()
  const toggleShowDialog = useAuthDialogStore()((s) => s.toggleShowDialog)
  const dict = useDictionary()
  const isB2BUser = useIsB2BUser()

  const menuItems = getMenuItems(dict, isB2BUser)

  const logout = () => {
    startTransition(async () => {
      clearCart()
      await fetch('/api/signout')

      window.location.assign('/')
    })
  }

  return !session ? (
    <Button onClick={toggleShowDialog} variant={'plain'} size={'plain'}>
      <Image
        priority
        src={'/icons/people.svg'}
        height={24}
        width={24}
        alt={'people'}
        className={`size-6 cursor-pointer`}
      />
    </Button>
  ) : (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger>
        <Image
          priority
          src={'/icons/people.svg'}
          height={24}
          width={24}
          alt={'people'}
          className={`size-6 cursor-pointer`}
        />
      </PopoverTrigger>
      <PopoverContent sideOffset={14} className="flex flex-col gap-4 p-6">
        <UserAvatar />
        {menuItems.map((item, index) => (
          <Link
            key={`menu-item-${index}`}
            href={item.href}
            className="flex items-center gap-2 overflow-hidden py-2"
            onClick={() => setIsOpen(false)}
          >
            <Image
              priority
              src={item.icon}
              height={24}
              width={24}
              alt={item.label}
              className="size-6 object-contain text-black"
            />
            <Text as="p">{item.label}</Text>
          </Link>
        ))}

        <Button
          variant="plain"
          size={'icon'}
          className="w-full"
          onClick={logout}
        >
          <Text className="w-full text-left font-semibold">
            {dict.userMenu.logout}
          </Text>
        </Button>
      </PopoverContent>
    </Popover>
  )
}

export default withCartStoreSuspense(UserMenu)
